import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { PATHS } from '@shared/constants';

import s from './NotFoundPage.module.css';

export function NotFoundPage() {
	const { t: tT } = useTranslation(i18TranslationNS);

	return (
		<section>
			<div className={s.notFoundPage_wrapper}>
				<h2 className={s.notFoundPage_text}>{tT(Translation.NOTFOUND_TITLE)}</h2>

				<Link to={PATHS.AUTH} className={s.notFoundPage_link} replace>
					{tT(Translation.NOTFOUND_LINK_TEXT)}
				</Link>
			</div>
		</section>
	);
}
